module.exports = __webpack_public_path__ + "media/images/emblems/Lueterkofen-blason-a7b1345eeb341995b24c9fed8a99820c.png";